import { useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { googleLogout } from '@react-oauth/google';

import { useApi } from '@/shared/api';
import { dpopKeyManager } from '@/shared/lib/crypto/dpop';
import { log } from '@/shared/utils/log';

export const useAppLogout = () => {
  const api = useApi();
  const apolloClient = useApolloClient();

  const [loading, setLoading] = useState(false);

  const appLogout = async () => {
    setLoading(true);

    const res = await api.authLogout();

    if (res.error) {
      log.error('[useAppLogout] appLogout error', res.error);
    }

    googleLogout();
    dpopKeyManager.clear();
    localStorage.clear();
    sessionStorage.clear();
    await apolloClient.resetStore();

    window.location.href = '/';
  };

  return { loading, appLogout };
};
